import { render, staticRenderFns } from "./setPrescription.vue?vue&type=template&id=03fb6adf&scoped=true"
import script from "./setPrescription.vue?vue&type=script&lang=js"
export * from "./setPrescription.vue?vue&type=script&lang=js"
import style0 from "./setPrescription.vue?vue&type=style&index=0&id=03fb6adf&prod&lang=scss&scoped=true"
import style1 from "./setPrescription.vue?vue&type=style&index=1&id=03fb6adf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb6adf",
  null
  
)

export default component.exports